module.exports = __webpack_public_path__ + "media/components/country-flag/static/sj-b8ef6aabafbcc0f34e634cc3e58a8f63.svg";